import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { TONE_CLASS } from '@/lib/tone'
import { cn } from '@/lib/utils'

const statusBadgeVariants = cva('inline-flex items-center gap-1 whitespace-nowrap rounded-full border font-medium', {
  variants: {
    tone: {
      neutral: TONE_CLASS.neutral,
      progress: TONE_CLASS.progress,
      success: TONE_CLASS.success,
      warning: TONE_CLASS.warning,
      danger: TONE_CLASS.danger,
      info: TONE_CLASS.info,
      highlight: TONE_CLASS.highlight,
      primary: 'border-transparent bg-primary text-primary-foreground'
    },
    size: {
      default: 'px-2 py-0.5 text-xs',
      count: 'tnum h-5 min-w-5 justify-center px-1.5 text-[10px] font-semibold'
    }
  },
  defaultVariants: {
    tone: 'neutral',
    size: 'default'
  }
})

export type StatusBadgeTone = NonNullable<VariantProps<typeof statusBadgeVariants>['tone']>

export interface StatusBadgeProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'>, VariantProps<typeof statusBadgeVariants> {}

export function StatusBadge({ className, tone, size, ...props }: StatusBadgeProps) {
  return <span className={cn(statusBadgeVariants({ tone, size }), className)} {...props} />
}

export { statusBadgeVariants }
